import React from "react";
import { HOW_IT_WORKS } from "../../data/programs";

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works"
      className="py-20 md:py-28"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <span className="text-xs uppercase tracking-[0.2em] text-aiou-gold font-semibold">
            How it works
          </span>
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl text-aiou-ink leading-[1.1] tracking-tight">
            From "I'm interested" to your first online lecture — in four
            simple steps.
          </h2>
        </div>

        <ol className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {HOW_IT_WORKS.map((s) => (
            <li
              key={s.n}
              data-testid={`step-${s.n}`}
              className="relative rounded-2xl border border-aiou-sand bg-white p-7 hover:border-aiou-gold/40 transition-colors"
            >
              <div className="font-serif text-5xl text-aiou-gold/40 leading-none">
                {s.n}
              </div>
              <h3 className="mt-4 font-serif text-xl text-aiou-ink leading-tight">
                {s.title}
              </h3>
              <p className="mt-3 text-sm text-aiou-slate leading-relaxed">
                {s.body}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
